import Slider from 'react-slick'; 
import  './PlatformTabSlide.css';
const PrevArrow = (props) => (
    <button {...props} className="slick-prev">
      <img src="/img/rentshield/claims_arrow_left.svg" alt="Previous" width="48" height="48" />
    </button>
  );
  
  const NextArrow = (props) => (
    <button {...props} className="slick-next">
      <img src="/img/rentshield/claims_arrow_right.svg" alt="Next" width="48" height="48" />
    </button>
  );


const PlatformTabSlide = ()=>{

// START cards
  // const cards = [
  //   { 
  //     id: 1, 
  //     image: '/img/Pricing/car_parking_2.svg',
  //     heading: 'Seamless Rental Management', 
  //     text: 'Handle bookings, rental agreements, and fleet operations from one centralized platform.' 
  //   },
  //   { 
  //     id: 2, 
  //     image: '/img/Pricing/car_2.svg',
  //     heading: 'Unlimited Vehicles & Locations', 
  //     text: 'Add and manage as many vehicles, users, and locations as your business needs—no restrictions.' 
  //   },
  //   { 
  //     id: 3, 
  //     image: '/img/Pricing/payment_2.svg',
  //     heading: 'Flexible Pricing & Payments', 
  //     text: 'Choose a plan that fits your business model and pay only when your vehicles are rented.' 
  //   },
  //   { 
  //     id: 4, 
  //     image: '/img/Pricing/analytics_up_2.svg',
  //     heading: 'Insights & Analytics', 
  //     text: 'Track fleet performance, analyze utilization trends, and make data-driven decisions.' 
  //   },
  //   { 
  //     id: 5, 
  //     image: '/img/Pricing/tools_2.svg',
  //     heading: 'Integrated Business Tools', 
  //     text: 'Access apps and automation features to streamline operations, payments, and customer interactions.' 
  //   },
  //  ];
// END cards



// START slick
const settings = {
  slidesToShow: 5,
  slidesToScroll: 1,
  margin: 30,
  autoplay: true,
  autoplaySpeed: 2000,
  // autoplaySpeed: 0,  // No delay between scrolls
  // speed: 4000,  // Smooth continuous movement
  // cssEase: 'linear',
  loop: true,
  dots: false,
  arrows: false,
  focusOnSelect: true,
  centerPadding: '30px',
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
  responsive: [
    {
      breakpoint: 1480,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4, // Correcting the key to 'slidesToShow'
        infinite: true,
        centerPadding: "30px",
        margin: 30,
      },
    },
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        infinite: true,
        margin: 30,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3, // Correcting the key to 'slidesToShow'
        margin: 20,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2, // Correcting the key to 'slidesToShow'
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Correcting the key to 'slidesToShow'
        centerPadding: "30px",
      },
    },
  ],
};
// END slick


    return(
        <>
            {/* START platformSlideMain */}
            <section className="platformSlideMain">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div className="platformSlideHead">
                                <h2>What Every Plan Gets You</h2>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div className='row justify-content-center'>
                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                      <Slider {...settings}>

                          <div className="item">
                            <div className="platformSlideDetail">
                              <img className="img-fluid" src="/img/Pricing/car_parking_2.svg" alt="Seamless Rental Management" />
                              <h3>Seamless Rental Management</h3>
                              <p>Handle bookings, rental agreements, and fleet operations from one centralized platform.</p>
                            </div>
                          </div> 
               
                          <div className="item">
                            <div className="platformSlideDetail">
                              <img className="img-fluid" src="/img/Pricing/car_2.svg" alt="Unlimited Vehicles & Locations" />
                              <h3>Unlimited Vehicles<br/> & Locations</h3>
                              <p>Add and manage as many vehicles,<br/> users, and locations as your business<br/> needs—no restrictions.</p>
                            </div>
                          </div>  

                          <div className="item">
                            <div className="platformSlideDetail">
                              <img className="img-fluid" src="/img/Pricing/payment_2.svg" alt="Flexible Pricing & Payments" />
                              <h3>Flexible Pricing<br/> & Payments</h3>
                              <p>Choose a plan that fits your business<br/> model and pay only when your<br/> vehicles are rented.</p>
                            </div>
                          </div>

                          <div className="item">
                            <div className="platformSlideDetail">
                              <img className="img-fluid" src="/img/Pricing/analytics_up_2.svg" alt="Insights & Analytics" />
                              <h3>Insights &<br/> Analytics</h3>
                              <p>Track fleet performance, analyze<br/> utilization trends, and make data-<br/>driven decisions.</p>
                            </div>
                          </div>

                          <div className="item">
                            <div className="platformSlideDetail">
                              <img className="img-fluid" src="/img/Pricing/tools_2.svg" alt="Integrated Business Tools" />
                              <h3>Integrated<br/> Business Tools</h3>
                              <p>Access apps and automation features<br/> to streamline operations, payments,<br/> and customer interactions.</p>
                            </div>
                          </div>

                      </Slider>
                  </div>
                </div> 
                  {/* <div className="platformSlideSlider">
                      <div className="carousel-container">
                          <div className="carousel">
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={card.id} className="platformSlideDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                             
                                <div className="carousel-track ">
                                  {cards.map((card) => (
                                    <div key={`duplicate-${card.id}`} className="platformSlideDetail">
                                      <img src={card.image} alt={card.heading1} className="img-fluid" />
                                      <h3>{card.heading}</h3>
                                      <p>{card.text}</p>
                                    </div>
                                  ))}
                                </div>
                          </div>
                      </div>
                  </div> */}
            </section>
            {/* END platformSlideMain */}
        </>
    )
}

export default PlatformTabSlide;